import { FC, useEffect, useState } from 'react';
import { useUserContext } from '../../providers/UserProvider';
import { seonService } from '../Account/seon/seon-service';
import { useTagsObjectQuery } from '../../libs/graphql/baseAppAPI/queries/__generated__/tags-get.query.generated';
import { xTenantId } from '../../consts';

export const SeonCheck: FC = () => {
  const { userProfileId, user } = useUserContext();
  const [seonServiceExecuted, setSeonServiceExecuted] = useState(false);
  const { data } = useTagsObjectQuery({
    variables: {
      xTenantId,
      externalResourceId: userProfileId,
      externalResource: 'UserProfileId',
    },
  });

  const hasSeonCheckedTag = (): boolean => {
    if (!data || !data.tagsObject || !Array.isArray(data.tagsObject)) {
      return false;
    }

    return data.tagsObject.some((tagObj) => tagObj.tag?.name?.includes('SEON'));
  };

  useEffect(() => {
    const runSeonService = async (): Promise<void> => {
      try {
        // Only proceed if:
        // We have all required data
        // User does NOT have the SEONChecked tag
        // The service hasn't been executed yet
        if (!seonServiceExecuted && userProfileId && user && data && !hasSeonCheckedTag()) {
          // Set flag before execution to prevent concurrent runs
          setSeonServiceExecuted(true);

          await seonService(user, userProfileId, 'account_login');
        } else if (hasSeonCheckedTag()) {
          // Also set the flag if the user already has the tag
          setSeonServiceExecuted(true);
        }
      } catch (error) {
        console.error('Error running Seon service:', error);
        // Don't reset the flag on error - we still attempted execution
      }
    };

    runSeonService();
  }, [userProfileId, user, data, seonServiceExecuted]);

  return null;
};
